import LoginForm from './login-form';
import ForgetPasswordForm from './forget-password-form';

export default {
	LoginForm,
	ForgetPasswordForm
};
